import { render, staticRenderFns } from "./Detalhes.vue?vue&type=template&id=1a45d43c"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"
import style0 from "./Detalhes.vue?vue&type=style&index=0&id=1a45d43c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports